"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import posthog from "posthog-js";

// posthog is already initialized in instrumentation-client.ts; pass the shared
// instance so React hooks (useFeatureFlagEnabled, <PostHogFeature>) used for
// experiments/A-B tests resolve against it without a second init.
export default function PostHogProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <PHProvider client={posthog}>{children}</PHProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}